import {tabs} from "./parts/tabs.js";
import {pop} from "./parts/pop.js";
import {quantity} from "./parts/quantity.js";

export const productHero = ()=> {
    tabs();

    pop();

    quantity();
}